import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TableResponse } from '../../models/table-response';
import { TableRequestData } from '../../models/table/table-request-param';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { ReportGenerateRequest } from '../../models/raport-generowanie';
import {
  ComparisonCycleDto,
  DictionaryItemDto,
  Raport,
} from '../../models/raport';
import { HttpUtils } from '../../utils/http.utils';

@Injectable({ providedIn: 'root' })
export class ReportsApi {
  #httpClient: HttpClient = inject(HttpClient);
  readonly #apiUrl = environment.API_EWNIOSKI + '/reports';

  public getReports$(
    tableRequest: TableRequestData,
  ): Observable<TableResponse<Raport>> {
    let params = HttpUtils.toHttpParams(tableRequest);
    return this.#httpClient.get<TableResponse<Raport>>(`${this.#apiUrl}`, {
      params,
      withCredentials: true,
    });
  }

  public getReportParameters$(reportId: number): Observable<string> {
    return this.#httpClient.get<string>(
      `${this.#apiUrl}/${reportId}/parameters`,
      {
        withCredentials: true,
      },
    );
  }

  public getStatusesDictionary$(): Observable<DictionaryItemDto[]> {
    return this.#httpClient.get<DictionaryItemDto[]>(
      `${this.#apiUrl}/comparison/statuses`,
      {
        withCredentials: true,
      },
    );
  }

  public getTypesDictionary$(): Observable<DictionaryItemDto[]> {
    return this.#httpClient.get<DictionaryItemDto[]>(
      `${this.#apiUrl}/comparison/application-types`,
      {
        withCredentials: true,
      },
    );
  }

  public getComparisonCycles$(): Observable<ComparisonCycleDto[]> {
    return this.#httpClient.get<ComparisonCycleDto[]>(
      `${this.#apiUrl}/comparison-cycles`,
      {
        withCredentials: true,
      },
    );
  }

  public generateReport$(payload: ReportGenerateRequest): Observable<void> {
    return this.#httpClient.post<void>(`${this.#apiUrl}`, payload, {
      withCredentials: true,
    });
  }

  public downloadReport$(reportId: number): Observable<HttpResponse<Blob>> {
    return this.#httpClient.get(`${this.#apiUrl}/${reportId}/download`, {
      observe: 'response',
      responseType: 'blob',
      withCredentials: true,
    });
  }

  public deleteReport$(reportId: number): Observable<void> {
    return this.#httpClient.delete<void>(`${this.#apiUrl}/${reportId}`, {
      withCredentials: true,
    });
  }
}
